import { useEffect, useRef } from 'react'
import type { Rect, Size } from '@/core/geometry'

interface PreviewCanvasProps {
  source: HTMLCanvasElement
  sourceRect: Rect
  outputSize?: Size
  testId?: string
  uploadNumber?: number
  className?: string
  ariaLabel: string
}

export function PreviewCanvas({
  source,
  sourceRect,
  outputSize = { width: 300, height: 400 },
  testId,
  uploadNumber,
  className,
  ariaLabel,
}: PreviewCanvasProps) {
  const canvasRef = useRef<HTMLCanvasElement>(null)

  useEffect(() => {
    const canvas = canvasRef.current
    if (!canvas) throw new Error('Preview canvas element is missing')
    const context = canvas.getContext('2d')
    if (!context) throw new Error('Preview canvas requires a 2D context')
    context.imageSmoothingEnabled = true
    context.imageSmoothingQuality = 'high'
    context.clearRect(0, 0, canvas.width, canvas.height)
    context.drawImage(
      source,
      sourceRect.x,
      sourceRect.y,
      sourceRect.width,
      sourceRect.height,
      0,
      0,
      canvas.width,
      canvas.height,
    )
  }, [source, sourceRect])

  return (
    <canvas
      ref={canvasRef}
      width={outputSize.width}
      height={outputSize.height}
      className={className}
      data-testid={testId}
      data-preview-upload-number={uploadNumber}
      aria-label={ariaLabel}
    />
  )
}
